import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { DateSharedCssClassName } from '@atlaskit/editor-common/styles';
import { akEditorDeleteBorder, akEditorSelectedBorderSize, akEditorSelectedNodeClassName, getSelectionStyles, SelectionStyle } from '@atlaskit/editor-shared-styles';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var dateNodeStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  "[data-prosemirror-node-name='date'] .date-lozenger-container span": {
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    color: "var(--ds-text, #172B4D)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-050, 4px)"),
    margin: '0 1px',
    position: 'relative',
    transition: 'background 0.3s',
    whiteSpace: 'nowrap',
    cursor: 'unset'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  "[data-prosemirror-node-name='date'] .date-lozenger-container span:hover": {
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  "[data-prosemirror-node-name='date'] .date-lozenger-container span.date-node-color-red": {
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    color: "var(--ds-text-accent-red, #AE2E24)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  "[data-prosemirror-node-name='date'] .date-lozenger-container span.date-node-color-red:hover": {
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
  }
});

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var dateStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t.", " {\n\t\t.", " {\n\t\t\tline-height: initial;\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t&.", " {\n\t\t\t.", " > span {\n\t\t\t\t", "\n\t\t\t}\n\t\t}\n\t}\n\n\t.danger {\n\t\t.", ".", "\n\t\t\t.", "\n\t\t\t> span {\n\t\t\tbox-shadow: 0 0 0 ", "px\n\t\t\t\t", ";\n\t\t}\n\t}\n"])), DateSharedCssClassName.DATE_CONTAINER, DateSharedCssClassName.DATE_WRAPPER, akEditorSelectedNodeClassName, DateSharedCssClassName.DATE_WRAPPER, getSelectionStyles([SelectionStyle.BoxShadow]), DateSharedCssClassName.DATE_CONTAINER, akEditorSelectedNodeClassName, DateSharedCssClassName.DATE_WRAPPER, akEditorSelectedBorderSize, "var(--ds-border-danger, ".concat(akEditorDeleteBorder, ")"));